// Catálogo de planos + plano contratado, in-memory (mock).
// Espelha o InMemoryAgencyPlanStore do agency-api. O plano ATIVO (aba "Plano") deriva
// do plano atual daqui + os seats em uso do roster (agencySeats).

export interface PlanFeature {
  label: string;
  included: boolean;
}

export interface PlanOption {
  code: string;
  name: string;
  priceCents: number;
  billingCycle: "monthly" | "yearly";
  seatsTotal: number;
  highlight: boolean;
  features: PlanFeature[];
}

const CATALOG: PlanOption[] = [
  {
    code: "starter",
    name: "Agency Starter",
    priceCents: 19900,
    billingCycle: "monthly",
    seatsTotal: 15,
    highlight: false,
    features: [
      { label: "15 licenças de corretor", included: true },
      { label: "Dashboards de produção da equipe", included: true },
      { label: "Convites e gestão de licenças", included: true },
      { label: "Suporte prioritário", included: false },
      { label: "Relatórios avançados (export)", included: false },
    ],
  },
  {
    code: "pro",
    name: "Agency Pro",
    priceCents: 49900,
    billingCycle: "monthly",
    seatsTotal: 50,
    highlight: true,
    features: [
      { label: "50 licenças de corretor", included: true },
      { label: "Dashboards de produção da equipe", included: true },
      { label: "Convites e gestão de licenças", included: true },
      { label: "Suporte prioritário", included: true },
      { label: "Relatórios avançados (export)", included: false },
    ],
  },
  {
    code: "business",
    name: "Agency Business",
    priceCents: 99900,
    billingCycle: "monthly",
    seatsTotal: 150,
    highlight: false,
    features: [
      { label: "150 licenças de corretor", included: true },
      { label: "Dashboards de produção da equipe", included: true },
      { label: "Convites e gestão de licenças", included: true },
      { label: "Suporte prioritário", included: true },
      { label: "Relatórios avançados (export)", included: true },
    ],
  },
];

let currentCode = "pro";

export function getPlanCatalogMock(): PlanOption[] {
  return CATALOG;
}

export function getCurrentPlanMock(): PlanOption {
  return CATALOG.find((p) => p.code === currentCode) ?? CATALOG[1]!;
}

/** Troca o plano atual. Retorna false se o código não existe no catálogo. */
export function setCurrentPlanMock(code: string): boolean {
  if (!CATALOG.some((p) => p.code === code)) return false;
  currentCode = code;
  return true;
}
